import { cn } from "@/lib/utils";
import * as SwitchPrimitive from "@radix-ui/react-switch";
import { forwardRef } from "react";

const Switch = forwardRef<
  React.ElementRef<typeof SwitchPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitive.Root
    className={cn(
      "relative w-11 h-6 bg-gray-200 dark:bg-gray-700 rounded-full peer shadow-inner",
      "focus:ring-4 focus:ring-brand-primary-300 dark:focus:ring-brand-primary",
      "data-[state=checked]:bg-brand-primary dark:data-[state=checked]:bg-brand-primary",
      className
    )}
    ref={ref}
    {...props}
  >
    <SwitchPrimitive.Thumb
      className={cn(
        "block absolute top-0.5 start-[2px] bg-white border-gray-300",
        "data-[state=unchecked]:border dark:border-0 rounded-full h-5 w-5 transition-transform shadow-sm",
        "data-[state=checked]:translate-x-full rtl:data-[state=checked]:-translate-x-full",
        "data-[state=checked]:border-white"
      )}
    />
  </SwitchPrimitive.Root>
));
Switch.displayName = SwitchPrimitive.Root.displayName;

export { Switch };
